/* global jQuery Drupal */
(function ($, Drupal) {
	/**
	 * Element help icon.
	 *
	 * @type {Drupal~behavior}
	 */
	Drupal.behaviors.webformElementHelpIconSpe = {
		attach: function (context) {
			if (!window.tippy) {
				return;
			}

			const hideOnEsc = {
				name: 'hideOnEsc',
				defaultValue: true,
				fn({ hide }) {
					function onKeyDown(event) {
						if (event.key === 'Escape') {
							hide();
						}
					}

					return {
						onShow() {
							document.addEventListener('keydown', onKeyDown);
						},
						onHide() {
							document.removeEventListener('keydown', onKeyDown);
						},
					};
				},
			};

			Drupal.webform.elementHelpIcon.options = {
				interactive: false,
				hideOnClick: true,
				plugins: [hideOnEsc],
			};
		},
	};
})(jQuery, Drupal);
